import { Component, Input, OnInit } from '@angular/core';
import { IncidentDto } from '@cradua/data';

@Component({
  selector: 'cradua-view-area-map-of-spill',
  templateUrl: './view-area-map-of-spill.component.html',
  styleUrls: ['./view-area-map-of-spill.component.scss']
})
export class ViewAreaMapOfSpillComponent implements OnInit {

  @Input() selectedIncidentId: IncidentDto;

  constructor() { }

  ngOnInit(): void {
  }

}
